import type { ToolDefinition } from "../types";
import removeImageMetadataTool from "./remove-image-metadata";
import securePasswordGeneratorTool from "./secure-password-generator";
import uuidGeneratorTool from "./uuid-generator";
import textHashGeneratorTool from "./text-hash-generator";
import encryptTextOnlineTool from "./encrypt-text-online";
import decryptTextOnlineTool from "./decrypt-text-online";
import pdfValidateTool from "./pdf-validate";
import pdfAddPasswordTool from "./pdf-add-password";
import pdfRemovePasswordTool from "./pdf-remove-password";

export const securityTools: ToolDefinition[] = [
  removeImageMetadataTool,
  securePasswordGeneratorTool,
  uuidGeneratorTool,
  textHashGeneratorTool,
  encryptTextOnlineTool,
  decryptTextOnlineTool,
  pdfValidateTool,
  pdfAddPasswordTool,
  pdfRemovePasswordTool,
];

export { default as removeImageMetadataTool } from "./remove-image-metadata";
export { default as securePasswordGeneratorTool } from "./secure-password-generator";
export { default as uuidGeneratorTool } from "./uuid-generator";
export { default as textHashGeneratorTool } from "./text-hash-generator";
export { default as encryptTextOnlineTool } from "./encrypt-text-online";
export { default as decryptTextOnlineTool } from "./decrypt-text-online";
export { default as pdfValidateTool } from "./pdf-validate";
export { default as pdfAddPasswordTool } from "./pdf-add-password";
export { default as pdfRemovePasswordTool } from "./pdf-remove-password";
